import { render, staticRenderFns } from "./CSATRating.vue?vue&type=template&id=2628762c&scoped=true&"
import script from "./CSATRating.vue?vue&type=script&lang=js&"
export * from "./CSATRating.vue?vue&type=script&lang=js&"
import style0 from "./CSATRating.vue?vue&type=style&index=0&id=2628762c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2628762c",
  null
  
)

export default component.exports